import app from "./app.json";
import auditLog from "./auditLog.json";
import errors from "./errors.json";
import modules from "./modules.json";
import notifications from "./notifications.json";


export default {
  ...app,
  ...auditLog,
  ...errors,
  ...modules,
  ...notifications
};